import { render, staticRenderFns } from "./Visualizacao.vue?vue&type=template&id=4a1fcfcd&scoped=true&"
import script from "./Visualizacao.vue?vue&type=script&lang=js&"
export * from "./Visualizacao.vue?vue&type=script&lang=js&"
import style0 from "./Visualizacao.vue?vue&type=style&index=0&id=4a1fcfcd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1fcfcd",
  null
  
)

export default component.exports